/* eslint-disable */

import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

// Views
import Dashboard from '@/views/Dashboard'
import Login from '@/views/Login'
// import Test from '@/views/Test'

// Purchase Orders
import PurchaseOrders from '@/views/po/pos'
import PurchaseOrder from '@/views/po/po'

// GRN with POs
import grns from '@/views/grn/grns'
import grn from '@/views/grn/grn'
// GRI
import gris from '@/views/gri/gris'
import gri from '@/views/gri/gri'

// GRO
import gros from '@/views/gro/gros'
import gro from '@/views/gro/gro'
// Stock Card Movement
import scm from '@/views/sm/scm'

// Stock Balance Record
import sbr from '@/views/sm/sbr'
// WTO
import wtos from '@/views/wto/wtos'
import wto from '@/views/wto/wto'
// WTR
import wtrs from '@/views/wtr/wtrs'
import wtr from '@/views/wtr/wtr'
// WSC
import wscs from '@/views/wsc/wscs'
import wsc from '@/views/wsc/wsc'
// SRF
import srfs from '@/views/srf/srfs'
import srf from '@/views/srf/srf'
// SRR
import srrs from '@/views/srr/srrs'
import srr from '@/views/srr/srr'

// SAN
import sans from '@/views/san/sans'
import san from '@/views/san/san'
//
import pods from '@/views/pod/pods'

// Stock Issuance
import wsis from '@/views/wsi/wsis'
import wsi from '@/views/wsi/wsi'
import pickListInfo from '@/views/wsi/picklistinfo'

import ssrs from '@/views/stockist/ssrs'
import ssr from '@/views/stockist/ssr'

// Reports
import pdr from '@/views/reports/pdr'
import pur from '@/views/reports/pur'
import bor from '@/views/reports/bor'
import po_grn_tracking from '@/views/reports/po_grn_tracking'
import srf_do_listing from '@/views/reports/srf_do_listing'
import sr_usage from '@/views/reports/sr_usage'
import gri_details from '@/views/reports/gri_details'

import pdfTest from '@/views/test/pdfTest'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      waitForData: true,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: { requiresAuth: true, functionName: '' }
        },
        {
          path: 'pos',
          name: 'Purchase Orders (POS)',
          component: PurchaseOrders,
          meta: { requiresAuth: true, functionName: 'po' }

        },
        {
          path: '/po/:poNum',
          name: 'Purchase Order (PO)',
          canReuse: false, // force to reload data
          component: PurchaseOrder,
          meta: { requiresAuth: true, functionName: 'po' }
        },
        {
          path: 'grns',
          name: 'Goods Receive Note (GRN) With PO',
          component: grns,
          meta: { requiresAuth: true, functionName: 'grn' }
        },
        {
          path: '/grn/:grnNum',
          name: 'Goods Received Note (GRN)',
          component: grn,
          meta: { requiresAuth: true, functionName: 'grn' }
        },
        {
          path: '/gro/:groNum',
          name: 'Goods Return Outwards Entry (GRO)',
          component: gro,
          meta: { requiresAuth: true, functionName: 'gro' }
        },
        {
          path: '/gros',
          name: 'Goods Return Outwards (GROS)',
          component: gros,
          meta: { requiresAuth: true, functionName: 'gro' }
        },
        {
          path: '/gri/:griNum',
          name: 'Goods Return Inwards Entry (GRI)',
          component: gri,
          meta: { requiresAuth: true, functionName: 'gri' }
        },
        {
          path: '/gris',
          name: 'Goods Return Inwards (GRIS)',
          component: gris,
          meta: { requiresAuth: true, functionName: 'gri' }
        },
        {
          path: '/scm',
          name: 'Stock Card Movement (SCM)',
          component: scm,
          meta: { requiresAuth: true, functionName: 'scm' }
        },
        {
          path: '/sbr',
          name: 'Stock Balance Record (SBR)',
          component: sbr,
          meta: { requiresAuth: true, functionName: 'sbr' }
        },
        {
          path: '/wto/:wtoNum',
          name: 'Warehouse Transfer Order Entry (WTO)',
          component: wto,
          meta: { requiresAuth: true, functionName: 'wto' }
        },
        {
          path: 'wtos',
          name: 'Warehouse Transfer Orders (WTOS)',
          component: wtos,
          meta: { requiresAuth: true, functionName: 'wto' }
        },
        {
          path: 'wtrs',
          name: 'Warehouse Transfer Receivings (WTRS)',
          component: wtrs,
          meta: { requiresAuth: true, functionName: 'wtr' }
        },
        {
          path: '/wtr/:wtrNum',
          name: 'Warehouse Transfer Receiving Entry (WTR)',
          component: wtr,
          meta: { requiresAuth: true, functionName: 'wtr' }
        },
        {
          path: 'wscs',
          name: 'Sales Cancellations (SCS)',
          component: wscs,
          meta: { requiresAuth: true, functionName: 'wsc' }
        },
        {
          path: '/wsc/:wscNum',
          name: 'Sales Cancellation Entry (SC)',
          component: wsc,
          meta: { requiresAuth: true, functionName: 'wsc' }
        },
        {
          path: 'srfs',
          name: 'Stock Requisition Forms (SRFS)',
          component: srfs,
          meta: { requiresAuth: true, functionName: 'srf' }
        },
        {
          path: '/srf/:srfNum',
          name: 'Stock Requisition Form Entry (SRF)',
          component: srf,
          meta: { requiresAuth: true, functionName: 'srf' }
        },
        {
          path: 'srrs',
          name: 'Stock Requisition Returns (SRRS)',
          component: srrs,
          meta: { requiresAuth: true, functionName: 'srr' }
        },
        {
          path: '/srr/:srrNum',
          name: 'Stock Requisition Return Entry (SRR)',
          component: srr,
          meta: { requiresAuth: true, functionName: 'srr' }
        },
        {
          path: 'sans',
          name: 'Stock Adjustment Notes (SANS)',
          component: sans,
          meta: { requiresAuth: true, functionName: 'san' }
        },
        {
          path: '/san/:sanNum',
          name: 'Stock Adjustment Note Entry (SAN)',
          component: san,
          meta: { requiresAuth: true, functionName: 'san' }
        },
        {
          path: 'wsis',
          name: 'Stock Issuance (SI)',
          component: wsis,
          meta: { requiresAuth: true, functionName: 'wsi' }
        },
        {
          path: '/wsi/:wsiNum',
          name: 'Stock Issuance Entry',
          component: wsi,
          meta: { requiresAuth: true, functionName: 'wsi' }
        },
        {
          path: '/wsi/pickinglist/:picklistNum',
          name: 'Picking List Info',
          component: pickListInfo,
          meta: { requiresAuth: true, functionName: 'wsi' }
        },
        {
          path: '/ssrs',
          name: 'Stockist Stock Replenishment',
          component: ssrs,
          meta: { requiresAuth: true, functionName: 'wsi' }
        },
        {
          path: '/pods',
          name: 'Proof Of Delivery (POD)',
          component: pods,
          meta: { requiresAuth: true, functionName: 'pod' }
        },
        {
          path: '/pdr',
          name: 'Product Delivered Report',
          component: pdr,
          meta: { requiresAuth: true, functionName: 'pdr' }
        },
        {
          path: '/pdf',
          name: 'Generate PDF',
          component: pdfTest,
          meta: { requiresAuth: true, functionName: 'pdr' }
        },
        {
          path: '/pur',
          name: 'Product Un-Delivered Report',
          component: pur,
          meta: { requiresAuth: true, functionName: 'pur' }
        },
        {
          path: '/bor',
          name: 'Back Order Report',
          component: bor,
          meta: { requiresAuth: true, functionName: 'bor' }
        },
        {
          path: '/po_grn_tracking',
          name: 'PO & GRN Tracking Report',
          component: po_grn_tracking,
          meta: { requiresAuth: true, functionName: 'po_grn_tracking' }
        },
        {
          path: '/srf_do_listing',
          name: 'SRF DO Listing Report',
          component: srf_do_listing,
          meta: { requiresAuth: true, functionName: 'srf_do_listing' }
        },
        {
          path: '/sr_usage',
          name: 'SRF Usage Report',
          component: sr_usage,
          meta: { requiresAuth: true, functionName: 'sr_usage' }
        },
        {
          path: '/gri_details',
          name: 'GRI Details Report',
          component: gri_details,
          meta: { requiresAuth: true, functionName: 'gri_details' }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { requiresAuth: false, functionName: 'login' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js